import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'

function redirectToLogin(message) {
  if (store.getters.loginRedirecting) {
    return
  }
  store.commit('SET_LOGIN_REDIRECTING', true)
  store.dispatch('logout')
  if (router.currentRoute.path !== '/login' && router.currentRoute.path !== '/register') {
    router.push('/login').catch(() => {})
  }
  if (message) {
    Message({ message, type: 'warning', duration: 3000 })
  }
}

const service = axios.create({
  baseURL: '/api',
  timeout: 15000
})

service.interceptors.request.use(
  config => {
    const token = store.getters.token
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    if (response.config.responseType === 'blob') {
      return response.data
    }
    const res = response.data
    if (res.code !== 200) {
      if (res.code === 401) {
        redirectToLogin(res.message || '登录已过期，请重新登录')
        return Promise.reject(new Error(res.message || '登录已过期，请重新登录'))
      }
      Message({
        message: res.message || '请求失败',
        type: 'error',
        duration: 3000
      })
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    return res
  },
  error => {
    error.data = error.response && error.response.data
    if (error.response && error.response.status === 401) {
      // 检查是否是密码错误，如果是则显示具体错误信息
      if (error.data && error.data.message && error.data.message.includes('密码错误')) {
        Message({ message: error.data.message, type: 'error', duration: 3000 })
      } else if (error.data && error.data.message && error.data.message.includes('用户名不存在')) {
        Message({ message: error.data.message, type: 'error', duration: 3000 })
      } else {
        // 其他401错误（如token过期）才提示登录过期
        redirectToLogin('登录已过期，请重新登录')
      }
    } else {
      Message({ message: (error.data && error.data.message) || error.message || '网络异常', type: 'error', duration: 3000 })
    }
    return Promise.reject(error)
  }
)

export default service
